import { useParams } from 'react-router-dom';
import { PropertyDetailPage } from './PropertyDetailsPage';

export function PropertyDetailPageWrapper() {
  const { propertyId } = useParams();
  return <PropertyDetailPage propertyId={propertyId} />;
}
